<script setup lang="ts">
import { Toaster } from '@/components/ui/sonner'
import 'vue-sonner/style.css'
</script>

<template>
  <RouterView />
  <!--
    Тосты снизу, а не сверху как в админке: приложение держат в руке, и верх
    экрана телефона — самое недосягаемое место, а под вырезом ещё и перекрыт.
  -->
  <Toaster position="bottom-center" rich-colors close-button />
</template>
